//@flow
import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { decodeToken } from 'session';

import { APP_NAME } from 'constants/enums';

type ContextFns = {
  emitCatchedError: () => void,
};

export const SentryContext = React.createContext<ContextFns>({
  emitCatchedError: () => {},
});

type Props = {
  children: React.Node,
};

export const SentryContextProvider = ({ children }: Props) => {
  Sentry.init({
    dsn: process.env.REACT_APP_RETAILER_APP_SENTRY_KEY,
    environment: process.env.NODE_ENV,
    integrations: [
      new Sentry.Integrations.Breadcrumbs({
        /**
         * Sometimes console.log has issues with sentry and gets into a loop.
         * Disable console.log breadcrumbs to avoid the issue.
         */
        console: false,
      }),
    ],
  });

  const emitCatchedError = (error) => {
    const decodedToken = decodeToken();
    Sentry.configureScope((scope) => {
      scope.setTag('appName', APP_NAME);
      scope.setUser({
        ID: (decodedToken && decodedToken.userId) || null,
        APP_NAME: APP_NAME,
        CLIENT_ID: (decodedToken && decodedToken.clientId) || null,
      });
    });

    Sentry.captureException(error);
  };

  return (
    <SentryContext.Provider
      value={{
        emitCatchedError,
      }}
    >
      {children}
    </SentryContext.Provider>
  );
};

export const SentryContextConsumer = SentryContext.Consumer;
